module.exports = __webpack_public_path__ + "img/jacob.9547641d.png";